import React from 'react';
import { useAuth } from '../context/AuthContext';

const UserProfile = () => {
  const { user, firebaseUser, logout } = useAuth();

  if (!user && !firebaseUser) return null;

  // Use Firebase user data if available, otherwise use backend user data
  const displayName = firebaseUser?.displayName || user?.name || 'User';
  const email = firebaseUser?.email || user?.email || '';
  const photoURL = firebaseUser?.photoURL || user?.picture || '';

  return (
    <div className="flex items-center gap-3">
      {photoURL && (
        <img
          src={photoURL}
          alt={displayName}
          className="w-10 h-10 rounded-full border-2 border-purple-500"
        />
      )}
      <div className="flex flex-col">
        <span className="text-sm font-semibold text-gray-800">{displayName}</span>
        <span className="text-xs text-gray-500">{email}</span>
      </div>
      <button
        onClick={logout}
        className="ml-4 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors text-sm font-semibold"
      >
        Logout
      </button>
    </div>
  );
};

export default UserProfile;

